import React from 'react';
import PolicyHeader from './PolicyHeader';
import Footer from './Footer';
import './TermsOfUse.css';

export default function TermsOfUse({ setIsLoginOpen, setIsSignupOpen, openEnroll }) {
  return (
    <div className="policy-container">
      <PolicyHeader />
      <main className="policy-content">
        <h1>Terms of Use</h1>

        <p>Welcome to KodeZ by Robokalam. By accessing this website, you agree to be bound by these terms and conditions.</p>

        <h3>I. General</h3>
        <ol className="roman">
          <li>This website is operated by Robokalam Technologies Pvt. Ltd. (“we”, “us”, or “our”).</li>
          <li>Access to our services is conditional on your acceptance of these Terms.</li>
        </ol>

        <h3>II. User Obligations</h3>
        <ol>
          <li>You must not misuse the platform by knowingly introducing viruses or harmful materials.</li>
          <li>You agree to use the content for personal, non-commercial use unless explicitly permitted.</li>
          <li>You agree to keep your login credentials confidential.</li>
        </ol>

        <h3>III. Intellectual Property</h3>
        <ul>
          <li>All content and materials on this platform are owned by or licensed to Robokalam.</li>
          <li>You are not allowed to reproduce, duplicate, copy or resell any part without permission.</li>
        </ul>

        <h3>IV. Limitation of Liability</h3>
        <ol className="roman">
          <li>We are not liable for any indirect or consequential loss or damage.</li>
          <li>We do not guarantee uninterrupted access or error-free functionality.</li>
        </ol>

        <h3>V. Termination</h3>
        <ol>
          <li>We may suspend or terminate access to the service immediately without prior notice for violation of terms.</li>
          <li>Upon termination, all licenses and rights granted to you will cease immediately.</li>
        </ol>

        <h3>VI. Changes to the Terms</h3>
        <ul>
          <li>We reserve the right to revise and update these Terms at any time.</li>
          <li>Changes will be posted on this page with updated revision dates.</li>
        </ul>

        <h3>Contact Us</h3>
        <p>If you have questions about these Terms, please contact us at <a href="mailto:team@robokalam.com">team@robokalam.com</a>.</p>
      </main>
      <Footer openEnroll={openEnroll}/>
    </div>
  );
}
